import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const fetchAllAgents = async ({ queryKey }) => {
    const { organisationId, projectId, access_token, token_type, } = queryKey[1]

    try {
        const response = await axiosInstance({
            url: `${ADMIN_API_URL}/agent/`,
            method: "GET",
            headers: {
                'org-id': `${organisationId}`,
                'proj-id': `${projectId}`,
                'Authorization': `${token_type} ${access_token}`
            },
            // params: { limit, skip: 0 }
        });

        return response;
    }
    catch (err) {
        console.log("Error in fetching agents: ", err);
    }
}

export const fetchAgentsDetails = async ({ queryKey }) => {
    const { agent_id, organisationId, projectId, access_token, token_type, } = queryKey[1];
    let response;
    try {
        response = await axiosInstance({
            url: `${ADMIN_API_URL}/agent/${agent_id}`,
            method: "GET",
            headers: {
                'org-id': `${organisationId}`,
                'proj-id': `${projectId}`,
                'Authorization': `${token_type} ${access_token}`
            },
            // params: { limit, skip: 0 }
        });
    }
    catch (err) {
        console.log("Error in fetching agent: ", err);
    }
    if (response?.status !== 200) {
        // throw new Error('No response from the network');
    }
    return response;
}

export const registerAgent = async (data) => {
    const { organisationId, projectId, access_token, token_type, payload } = data;

    try {
        const response = await axiosInstance({
            url: `${ADMIN_API_URL}/agent/`,
            method: "POST",
            headers: {
                'org-id': `${organisationId || 1}`,
                'proj-id': `${projectId || 1}`,
                'Authorization': `${token_type} ${access_token}`
            },
            data: payload
        });

        console.log("Agent registration response:", response);

        if (response?.status !== 200) {
            throw new Error('No response from the network');
        }
        return "ok";
    } catch (error) {
        console.error("Error registering agent:", error);
        throw error;
    }
}
export const updateExistingAgent = async (data) => {
    const { organisationId, projectId, access_token, token_type, agent_id, payload } = data;

    try {
        const response = await axiosInstance({
            url: `${ADMIN_API_URL}/agent/${agent_id}`,
            method: "POST",
            headers: {
                'org-id': `${organisationId || 1}`,
                'proj-id': `${projectId || 1}`,
                'Authorization': `${token_type} ${access_token}`
            },
            data: payload
        });

        console.log("Agent update response:", response);

        if (response?.status !== 200) {
            throw new Error('No response from the network');
        }
        return "ok";
    } catch (error) {
        console.log("Error updating agent:", error);
        throw error;
    }
}

// deleteAgent
export const deleteAgent = async ({ id, organisationId, projectId, access_token, token_type }) => {
    await axiosInstance({
        url: `${ADMIN_API_URL}/agent/${id}`,
        method: "DELETE",
        headers: {
            'org-id': `${organisationId}`,
            'proj-id': `${projectId}`,
            'Authorization': `${token_type} ${access_token}`
        },
    });
}

export const publishAgent = async (data) => {
    const { organisationId, projectId, access_token, token_type, agent_id, payload } = data;

    let response;

    try {
        response = await axiosInstance({
            url: `${ADMIN_API_URL}/agent/${agent_id}/approve-reject`,
            method: "POST",
            headers: {
                'org-id': `${organisationId || 1}`,
                'proj-id': `${projectId || 1}`,
                'Authorization': `${token_type} ${access_token}`
            },
            data: payload
        });

        console.log("Agent update response:", response);

        if (response?.status !== 200) {
            throw new Error('No response from the network');
        }
    } catch (error) {
        console.log("Error updating agent:", error);
        throw error;
    }

    return response;
}
export const getAgentCategoriesAPI = async ({ queryKey }) => {
    const { organisationId, projectId, access_token, token_type } = queryKey[1];
    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/lookup/agent_category`,
        method: "GET",
        headers: {
            "org-id": `${organisationId}`,
            "proj-id": `${projectId}`,
            Authorization: `${token_type} ${access_token}`,
        },
    });
    if (response?.status !== 200) {
        throw new Error("No response from the network");
    }

    // console.log('resoponse from Models RQ', response);
    return response?.data;
};


export const getAgentAllVersionsAPI = async (headData, agentId) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/agent/${agentId}/version`,
        method: "GET",
        headers: headers,
    });

    return response || null;
}